import * as Yup from 'yup';

export default Yup.object().shape({
    name: Yup.string().required(),
    confirmed: Yup.boolean().required(),
    price: Yup.number(),
    description: Yup.string().required(),
});